const KEYS_SYMBOLS_CONFIG = {
  size: 0.07,
  offsetY: 0.015,
  atlasSize: 10,
}

export { KEYS_SYMBOLS_CONFIG };
